module.exports = __webpack_public_path__ + "img/hongbao_chai.e57e2d28.png";